import { render, staticRenderFns } from "./fccClassificacaoTabela.vue?vue&type=template&id=29c87ce9"
import script from "./fccClassificacaoTabela.vue?vue&type=script&lang=js"
export * from "./fccClassificacaoTabela.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports